import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router, Route, withRouter} from 'react-router-dom';
import App from './App';
import Article from './components/Article';
import './index.css';
import Articles from './articleData.jsx';
import * as serviceWorker from './serviceWorker';

const articles = Articles.articles;

const articleRoutes = articles.map((element) => {
    let dict = {
        component: () => <Article 
            headline={element.headline}
            image={element.image}
            logo={element.logo}
            subheadline={element.subheadline}
            authorName={element.authorName}
            authorPosition={element.authorPosition}
            articleText={element.articleText}
            url={element.url}
            theme={element.theme}
        />,
        url: element.url
    };
    return dict;
})        
       
console.log(articleRoutes);

class ScrollToTop extends Component {
    componentDidUpdate(prevProps) {
      if (this.props.location !== prevProps.location) {
        window.scrollTo(0, 0)
      }
    }
  
    render() {
      return this.props.children
    }
  }
  
  export default withRouter(ScrollToTop)

ReactDOM.render(
    <Router basename={process.env.PUBLIC_URL}>
        <ScrollToTop>
        <Route exact path={`/`} component={App} />
        {articleRoutes.map((article) => <Route exact path={`${article.url}`} component={article.component} />)}
        </ScrollToTop>
    </Router>, 
    document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
